export default __webpack_public_path__ + "static/media/Jeroen@2x.c05e013a.jpg";